import { createRoutine } from 'redux-saga-routines';

export const setActiveEducationPeriod = createRoutine(
  'GROUP_FILTERS/STORE_ACTIVE_EDUCATION_PERIOD',
);
